import script from "./QueueBlocksWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueBlocksWidget.vue?vue&type=script&setup=true&lang=ts"

import "./QueueBlocksWidget.vue?vue&type=style&index=0&id=a62792ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a62792ec"]])

export default __exports__